import React from 'react'
import InstructorCoursecontentpopup from '../components/courseContent/InstructorCoursecontentpopup'
import InstructorNavbar from '../components/instructor/InstructorNavbar'


const InstructorCoursecontentpopupPage = () => {
  return (
    <>
   
    <InstructorNavbar/>
    <InstructorCoursecontentpopup/>
    </>
  )
}

export default InstructorCoursecontentpopupPage